export interface PublicLeadSignupInput {
  firstName: string;
  lastName: string;
  email: string;
  location?: string;
}

export type CreatePublicLeadResult =
  | { ok: true; slug: string; url: string; duplicate?: boolean }
  | { ok: false; error: string };

const FUNCTIONS_BASE = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID || 'lctf-projects'}.cloudfunctions.net`;

export function parsePendingLeadParams(search: string): PublicLeadSignupInput | null {
  const p = new URLSearchParams(search);
  let firstName = p.get('fn')?.trim() || '';
  let lastName = p.get('ln')?.trim() || '';

  if (!firstName && !lastName && p.get('name')) {
    const parts = (p.get('name') || '').trim().split(/\s+/);
    firstName = parts[0] || '';
    lastName = parts.slice(1).join(' ') || parts[0] || '';
  }

  const email = p.get('email')?.trim() || '';
  const location = p.get('loc')?.trim() || p.get('location')?.trim() || '';

  if (!firstName || !lastName || !email) return null;

  return { firstName, lastName, email, location };
}

export async function createPublicQuestionnaireLead(
  input: PublicLeadSignupInput
): Promise<CreatePublicLeadResult> {
  try {
    const res = await fetch(`${FUNCTIONS_BASE}/createPublicLead`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: input.firstName,
        lastName: input.lastName,
        email: input.email,
        location: input.location || '',
      }),
    });

    const data = await res.json();

    if (!data.success || !data.url) {
      return {
        ok: false,
        error: data.error || 'Could not start your questionnaire. Please try again.',
      };
    }

    const slugMatch = data.url.match(/\/portal\/([^/]+)\//);
    if (!slugMatch) {
      return { ok: false, error: 'Could not start your questionnaire. Please try again.' };
    }

    return {
      ok: true,
      slug: slugMatch[1],
      url: data.url,
      duplicate: !!data.duplicate,
    };
  } catch {
    return { ok: false, error: 'Could not start your questionnaire. Please try again.' };
  }
}
